import { ApplicantApplierRelationType } from '@/commons/constants/application'

export class CarePerson {
    fullName: string;
    personCode: string;
    personStatusType: ApplicantApplierRelationType;

    constructor (fullName: string, personCode: string, personStatusType: ApplicantApplierRelationType) {
        this.fullName = fullName
        this.personCode = personCode
        this.personStatusType = personStatusType
    }
}
